/**
 * Thrown when Shopify rejects the access token (expired/invalid), vs. a transient
 * network/GraphQL failure. Callers tear down the session only on this error.
 */
export class UnauthorizedError extends Error {
  constructor(message = 'Unauthorized') {
    super(message)
    this.name = 'UnauthorizedError'
  }
}

export const isUnauthorizedError = (error: unknown): error is UnauthorizedError =>
  error instanceof UnauthorizedError

/**
 * Thrown when the Storefront API responds successfully but returns no product for a GID,
 * meaning it's deleted or unpublished from the sales channel, vs. a transient network/rate
 * limit failure (already retried by the client, see shopify/index.ts). Callers can treat this
 * as a definitive "not found" instead of a generic outage.
 */
export class ProductNotFoundError extends Error {
  constructor(id: string) {
    super(`Product not found: ${id}`)
    this.name = 'ProductNotFoundError'
  }
}

export const isProductNotFoundError = (error: unknown): error is ProductNotFoundError =>
  error instanceof ProductNotFoundError
